import { ICreditCardType } from "@app/shared/payment.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const creditCardTypeAdapter: EntityAdapter<ICreditCardType> = createEntityAdapter<ICreditCardType>({
	selectId: type => type.id
});